import { environment } from '@environments/environment';
import { ProgramSubmissionType } from './program.model';

export class ProgramApplicationConstant {
  public static programs = environment.serverUri + `api/${environment.apiVersion}/programs`;

  public static stageConfiguration = {
    list: (programId: string) => {
      return `${ProgramApplicationConstant.programs}/${programId}/program-application-stage-configurations`;
    },
    create: (programId: string) => {
      return `${ProgramApplicationConstant.programs}/${programId}/program-application-stage-configurations`;
    },
    delete: (programId: string, programAppStageConfigId: string) => {
      return `${ProgramApplicationConstant.programs}/${programId}/program-application-stage-configurations/${programAppStageConfigId}`;
    },
    detail: (programId: string, programAppStageConfigId: string) => {
      return `${ProgramApplicationConstant.programs}/${programId}/program-application-stage-configurations/${programAppStageConfigId}`;
    },
    update: (programId: string, programAppStageConfigId: string) => {
      return `${ProgramApplicationConstant.programs}/${programId}/program-application-stage-configurations/${programAppStageConfigId}`;
    }
  };

  public static application = {
    list: (programId: string) => {
      return `${ProgramApplicationConstant.programs}/${programId}/applications`;
    },
    update: (programId: string) => {
      return `${ProgramApplicationConstant.programs}/${programId}/applications`;
    },
    createAll: (programId: string) => {
      return `${ProgramApplicationConstant.programs}/${programId}/applications/create-all`;
    },
    detail: (programId: string, applicationId: string) => {
      return `${ProgramApplicationConstant.programs}/${programId}/applications/${applicationId}`;
    },
    status: (programId: string, applicationId: string, status: string) => {
      return `${ProgramApplicationConstant.programs}/${programId}/applications/${applicationId}/${status}`;
    },
    exportResponsesXLS: (programId: string, configId: string) => {
      return `${ProgramApplicationConstant.programs}/${programId}/applications/export-responses/stage-config/${configId}`;
    },
  };
}

